import React, { useMemo } from "react";
import { Bill } from "@common/types/bill";
import { filterTemplatesForBill } from "@components/accounting/schedules/billScheduleTemplates";
import { SchedulePicker } from "@components/accounting/schedules/SchedulePicker";
import { usePanelScheduleTemplates } from "@components/accounting/schedules/usePanelScheduleTemplates";
import { toScheduleCardValues } from "@components/invoices/views/scheduleCellState";
import accountFieldStyles from "@components/transactions/TransactionDetails/TransactionDetailsAccount.module.scss";
import { BillScheduleCellContent } from "./BillScheduleCellContent";
import { BillScheduleCallbacks } from "./useBillScheduleCallbacks";
import { useBillRowSchedule } from "./useBillRowSchedule";

interface Props {
    bill: Bill;
    callbacks: BillScheduleCallbacks;
}

export const BillDetailsSchedule: React.FC<Props> = ({ bill, callbacks }) => {
    const entityTemplates = usePanelScheduleTemplates(bill.entityId);
    const scheduleTemplates = useMemo(
        () => filterTemplatesForBill(entityTemplates),
        [entityTemplates],
    );
    const schedule = useBillRowSchedule({ bill, callbacks });

    if (schedule.kind === "static") {
        return <BillScheduleCellContent state={schedule.state} />;
    }

    return (
        <>
            <SchedulePicker
                compact
                compactEmptyLabel="Assign expense schedule"
                compactTriggerClassName={accountFieldStyles.ledgerTrigger}
                templates={scheduleTemplates}
                applied={toScheduleCardValues(schedule.state)}
                {...schedule.pickerProps}
            />
            {schedule.overlays}
        </>
    );
};
